"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupAdapter = exports.InputGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputGroup = require("../InputGroup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputGroup = function InputGroup(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      atts = _ref.atts,
      label = _ref.label,
      helper = _ref.helper,
      cashbotName = _ref.cashbotName,
      isRequiredField = _ref.isRequiredField,
      hasMaxLengthCounter = _ref.hasMaxLengthCounter,
      counterAriaLabel = _ref.counterAriaLabel,
      wrappedElement = _ref.wrappedElement,
      showUntouchedErrors = _ref.showUntouchedErrors,
      doFocus = _ref.doFocus,
      showHelper = _ref.showHelper,
      submitButton = _ref.submitButton;

  var fieldAttributes = _objectSpread({}, input, atts);

  return _react.default.createElement(_InputGroup.InputGroup, {
    fieldName: input.name,
    value: input.value,
    atts: fieldAttributes,
    label: label,
    helper: helper,
    cashbotName: cashbotName,
    hasMaxLengthCounter: hasMaxLengthCounter,
    counterAriaLabel: counterAriaLabel,
    isActive: meta.active,
    isInvalid: meta.invalid,
    isTouched: meta.touched,
    warningMessage: meta.warning,
    errorMessage: meta.error,
    isRequiredField: isRequiredField,
    wrappedElement: wrappedElement,
    showUntouchedErrors: showUntouchedErrors,
    doFocus: doFocus,
    showHelper: showHelper,
    submitButton: submitButton
  });
};

exports.InputGroup = InputGroup;
InputGroup.defaultProps = {
  doFocus: false,
  helper: '',
  hasMaxLengthCounter: false,
  counterAriaLabel: null,
  isRequiredField: true,
  showUntouchedErrors: false,
  wrappedElement: null,
  // optional element icon/image inside FieldDivWrapper for positioning
  showHelper: false,
  submitButton: null
};
InputGroup.propTypes = {
  atts: _propTypes.default.shape({
    maxLength: _propTypes.default.number.isRequired,
    type: _propTypes.default.oneOf(['email', 'tel', 'text'])
  }).isRequired,
  input: _propTypes.default.object.isRequired,
  meta: _propTypes.default.object.isRequired,
  helper: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  hasMaxLengthCounter: _propTypes.default.bool,
  counterAriaLabel: function counterAriaLabel(props, propName, componentName) {
    return props.hasMaxLengthCounter && (props[propName] === undefined || typeof props[propName] !== 'function') ? new Error("".concat(propName, " must be a function when hasMaxLengthCounter is true (component: ").concat(componentName, ")")) : undefined;
  },
  isRequiredField: _propTypes.default.bool,
  showUntouchedErrors: _propTypes.default.bool,
  wrappedElement: _propTypes.default.node,
  doFocus: _propTypes.default.bool,
  showHelper: _propTypes.default.bool,
  submitButton: _propTypes.default.shape({
    btnText: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })
};
var InputGroupAdapter = InputGroup;
exports.InputGroupAdapter = InputGroupAdapter;